import Image from "next/image";
import { CategoryDescriptionWithImageProps } from "@/utils/formatCategoryPage";
import { injectPurifiedHTML } from "@/utils/injectPurifiedHTML";
import { addBasePathToStrapiMedia, formatStrapiEntity } from "@/utils/strapi";
import { removeEmptyRel } from "@/utils/removeEmptyRel";
import styles from "./CategoryDescriptionWithImage.module.scss";

export const CategoryDescriptionWithImage = ({
  title,
  image,
  text,
}: CategoryDescriptionWithImageProps) => {
  const strapiImage = formatStrapiEntity(image);

  return (
    <div className={styles.categoryDescription}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.description}>
        <div className={styles.descriptionImage}>
          <Image
            src={addBasePathToStrapiMedia(strapiImage)}
            objectFit="contain"
            objectPosition="center"
            alt={strapiImage.alternativeText ?? ""}
            layout="fill"
          />
        </div>
        <div
          className={styles.descriptionText}
          dangerouslySetInnerHTML={injectPurifiedHTML(removeEmptyRel(text))}
        />
      </div>
    </div>
  );
};
